import { useEffect, useState } from 'react';

/** Wide enough to show two booklet pages side by side. */
const WIDE = '(min-width: 900px)';

/** Whether the screen is wide enough for two-page spreads, following rotation and resizing. */
export function useWideScreen() {
  const [wide, setWide] = useState(() => window.matchMedia(WIDE).matches);

  useEffect(() => {
    const query = window.matchMedia(WIDE);
    const onChange = () => setWide(query.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);

  return wide;
}
